const slug = (part) => String(part)
  .trim()
  .toLowerCase()
  .replace(/[^a-z0-9_]+/g, '-')
  .replace(/^-+|-+$/g, '');

export const testId = (...parts) => parts
  .filter((part) => part !== null && part !== undefined && String(part).trim() !== '')
  .map(slug)
  .filter(Boolean)
  .join('-');
